import AxiosMockAdapter from 'axios-mock-adapter';
import {api} from 'api';

const axiosMockAdapter = new AxiosMockAdapter(api, {delayResponse: 1000});

export default axiosMockAdapter;
